/**
 * @generated SignedSource<<d8ffa5e2715a92f25c559cae803d2e4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsPhotosTracking_searchBrowsePhoto$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "interiorsPhotosTracking_searchBrowsePhoto";
};
export type interiorsPhotosTracking_searchBrowsePhoto$key = {
  readonly " $data"?: interiorsPhotosTracking_searchBrowsePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"interiorsPhotosTracking_searchBrowsePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsPhotosTracking_searchBrowsePhoto"
};

(node as any).hash = "da5a623af0579fdc3f6ee15d77b9b89b";

export default node;
